import { z } from 'zod';

import { PlaceAnatomySchema } from '../organizations/provision-organization.schemas.js';

/** Read model — legacy rows may lack geo FKs; write path still uses `PlaceAnatomySchema`. */
export const PlaceAddressReadSchema = z.object({
  countryId: z.uuid().nullable(),
  stateId: z.uuid().nullable().optional(),
  cityId: z.uuid().nullable().optional(),
  stateText: z.string().nullable().optional(),
  cityText: z.string().nullable().optional(),
  zipCode: z.string().nullable().optional(),
  street: z.string().min(1),
  number: z.string().nullable().optional(),
  complement: z.string().nullable().optional(),
  neighborhood: z.string().nullable().optional(),
  reference: z.string().nullable().optional(),
});

export const PlaceAnatomyReadSchema = PlaceAnatomySchema.extend({
  address: PlaceAddressReadSchema,
});

export const GetPlaceResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  active: z.boolean(),
  isCentralDistribution: z.boolean(),
  anatomy: PlaceAnatomyReadSchema,
  organization: z.object({
    id: z.uuid(),
    name: z.string(),
    slug: z.string(),
  }),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type GetPlaceResponse = z.infer<typeof GetPlaceResponseSchema>;
